import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ScheduledMaintenanceTaskStatus, ScheduledMaintenanceTaskTenantDetails } from '../scheduled-maintenance-task.model';
import { ScheduledMaintenanceSummary } from '../scheduled-maintenance-summary.model';
import { MaintenanceTaskSchedulerDataService } from '../maintenance-task-scheduler-data.service';
import { Observable, Subject, Subscription } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { Tenant } from '@app/Models/tenant';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatExpansionPanelDescription } from '@angular/material/expansion';
import { MatIcon } from '@angular/material/icon';
import { JsonPipe, DatePipe } from '@angular/common';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'maintenance-schedule',
    templateUrl: './maintenance-schedule.component.html',
    styleUrls: ['./maintenance-schedule.component.less'],
    imports: [MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatIcon, MatExpansionPanelDescription, MatFormField, MatLabel, MatInput, CdkTextareaAutosize, MatButton, JsonPipe, DatePipe]
})
export class MaintenanceScheduleComponent implements OnInit, OnDestroy {
  @Input() schedule: ScheduledMaintenanceSummary;
  @Input() allTenants$: Observable<Tenant[]>;
  @Output() refreshRequested: EventEmitter<void> = new EventEmitter<void>();

  destroy$: Subject<boolean> = new Subject<boolean>();
  tenants: ScheduledMaintenanceTaskTenantDetails[] = [];

  private subscription: Subscription = undefined;
  private allTenantsSubscription: Subscription = undefined;
  private allTenants: Tenant[] = [];

  constructor(private migrationToolDataService: MaintenanceTaskSchedulerDataService) { }

  ngOnInit(): void {
    this.allTenantsSubscription = this.allTenants$.subscribe(tenants => this.allTenants = tenants);
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.allTenantsSubscription?.unsubscribe();
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  expanded(): void {
    this.fetchTenants();
  }

  onCancel(summary: ScheduledMaintenanceSummary): void {
    this.migrationToolDataService.cancelScheduledMaintenanceTask(summary.TaskTypeName, summary.Id)
      .pipe(takeUntil(this.destroy$))
      .toPromise().then( r => {
        this.refreshRequested.emit();
      }).catch((e) => console.log(e));
  }

  canBeCancelled(overallStatus: string): boolean {
    return overallStatus !== ScheduledMaintenanceTaskStatus.Completed
      && overallStatus !== ScheduledMaintenanceTaskStatus.Cancelled;
  }

  getTenantsForStatus(status: string): ScheduledMaintenanceTaskTenantDetails[] {
    return this.tenants.filter(tenant => tenant.Status === status);
  }

  private fetchTenants(): void {
    this.subscription = this.migrationToolDataService.getSchedule(this.schedule.TaskTypeName, this.schedule.Id).subscribe(
      task => {
        this.tenants = task.Tenants;
        this.tenants.forEach(tenant => tenant.Name = this.getTenantName(tenant.TenantId));
      }
    );
  }

  private getTenantName(tenantId: string) {
    const tenant = this.allTenants.find(t => t.TenantId.toLocaleLowerCase() === tenantId.toLocaleLowerCase());
    return tenant?.Text;
  }
}
